module.exports = __webpack_public_path__ + "img/f4-1.f5a40f96.png";